import { CustomerStateInterface } from "./types";
import Customer from "@/types/customer/Customer";
import Investment from "@/types/app/investment";
import Notification from "@/types/app/notifications";
import Schedule from "@/types/app/schedules";
import NotificationInterface from "@/types/app/notifications";

export default {
  setCustomers(state: CustomerStateInterface, customers: Customer[]) {
    state.customers = customers;
  },

  removeCustomers(state: CustomerStateInterface, ids:string[]) {
    state.customers = state.customers.filter(c => !ids.some(i => i == c.id));
  },

  setCustomer(state: CustomerStateInterface, customer: Customer) {
    state.customer = customer;
  },
  setLoading(state: CustomerStateInterface, loading: boolean) {
    state.loading = loading;
  },
  setModalInterestState(state: CustomerStateInterface, show: boolean) {
    state.modalInterest = show;
  },
  setModalCreateInterestState(state: CustomerStateInterface, show: boolean) {
    state.modalCreateInterest = show;
  },
  setModalImportInterestState(state: CustomerStateInterface, show: boolean) {
    state.modalImportInterest = show;
  },
  setModalAccountMirrorState(state: CustomerStateInterface, show: boolean){
    state.modalAccountMirror = show;
  },
  setModalInvestmentState(state: CustomerStateInterface, show: boolean) {
    state.modalInvestment = show;
  },
  setModalNewNotificationState(state: CustomerStateInterface, show: boolean) {
    state.modalNewNotification = show;
  },
  setModalNotificationState(state: CustomerStateInterface, show: boolean) {
    state.modalNotification = show;
  },
  setModalJobInfoState(state: CustomerStateInterface, show: boolean) {
    state.modalJobInfo = show;
  },
  setModalCustomerState(state: CustomerStateInterface, show: boolean) {
    state.modalCustomer = show;
  },
  setModalRefusedState(state: CustomerStateInterface, show: boolean) {
    state.modalRefused = show;
  },
  setModalRefuseState(state: CustomerStateInterface, show: boolean) {
    state.modalRefuse = show;
  },
  setModalMessageState(state: CustomerStateInterface, show: boolean) {
    state.modalMessage = show;
  },
  setInvestmentState(state: CustomerStateInterface, investment: Investment) {
    state.investment = investment;
  },
  removeCustomerFromList(state: CustomerStateInterface, remover: any) {
    for (let i = 0; i < state.customers.length; i++) {
      if (state.customers[i].id == remover.id) {
        state.customers[i].status = remover.status;
        state.customers[i].relationship = remover.evaluator;
        state.customers[i].relationships.push({
          name: remover.evaluator,
          typeRelationship: 0,
        });
      }
    }
  },
  setNotificationState(
    state: CustomerStateInterface,
    notification: Notification
  ) {
    state.notification = notification;
  },
  setNotificationsState(
    state: CustomerStateInterface,
    notifications: NotificationInterface[]
  ) {
    state.notifications = notifications;
  },  
  setNotificationSent(state: CustomerStateInterface, show: boolean) {
    state.notificationSent = show;
  }, 
  setModalDeleteState(state: CustomerStateInterface, show: boolean) {
    state.ModalDeleteState = show;
  },
  setUndoRefused(state: CustomerStateInterface, show: boolean) {
    state.undoRefused = show;
  },

  setScheduleState(state: CustomerStateInterface, schedule: Schedule) {
    state.schedule = schedule;
  },
  setModalScheduleState(state: CustomerStateInterface, show: boolean) {
    state.modalSchedule = show;
  },
  setScheduleFeedbackModalState(state: CustomerStateInterface, show: boolean) {
    state.scheduleFeedbackModal = show;
  },
};
